import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ExternalRedirect from "@/components/ExternalRedirect";
import Screens from "@/pages/Screens";
import { Toaster } from "sonner";
import ScrollToTop from "@/components/ScrollToTop";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import DeleteAccount from "@/pages/DeleteAccount";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/delete-account" element={<DeleteAccount />} />
            <Route path="/schermen" element={<Screens />} />
            <Route path="/login" element={<ExternalRedirect />} />
            <Route path="/app" element={<ExternalRedirect />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
